import { motion } from "framer-motion";
import { PropsWithChildren } from "react";

interface IExpandAnimationProps {
  className?: string;
}

const ExpandAnimation = ({
  children,
  className,
}: PropsWithChildren<IExpandAnimationProps>) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        height: 0,
      }}
      animate={{
        opacity: 1,
        height: "auto",
        transition: {
          type: "tween",
          duration: 0.2,
          ease: "easeOut",
        },
      }}
      exit={{
        opacity: 0,
        height: 0,
        transition: {
          type: "tween",
          duration: 0.2,
          ease: "easeOut",
        },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ExpandAnimation;
